




































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import Judge from '@/evaluations/entities/judge'
import cloneDeep from 'lodash/cloneDeep'

@Component
export default class JudgeDialog extends Vue {
  @Ref()
  protected validator!: ValidationObserver

  protected dialog = false
  protected loading = false
  protected model: Judge[] = []

  public openNew(model: Judge[]) {
    this.openInternal(model)
  }

  public cancel() {
    this.$emit('cancel')
    this.dialog = false
  }

  public close() {
    this.dialog = false
  }

  private openInternal(model: Judge[]) {
    this.loading = false
    this.model = cloneDeep(model)
    this.dialog = true
    Vue.nextTick(() => {
      this.resetValidator()
    })
  }

  protected async confirm() {
    if (await this.validator.validate()) {
      this.loading = true
      this.emitConfirm()
      this.close()
    }
  }

  protected emitConfirm() {
    this.$emit('create', this.model)
  }

  private resetValidator() {
    // For some odd reason, the validator is not ready upon first invocation
    // of the dialog.
    if (this.validator) {
      this.validator.reset()
    }
  }
}
